import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import UserPost from "../../components/UserPost/UserPost";

const UserMain = () => {
	return (
		<>
			<Navbar></Navbar>
			<UserPost></UserPost>
		</>
	);
};

export default UserMain;
